import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components/ui/button';

type Props = {
  collapsed: boolean;
};

const SidebarPrimeBlock = ({ collapsed }: Props) => {
  const { t } = useTranslation();

  if (collapsed) {
    return (
      <div className="size-[3.6rem] rounded-[0.8rem] bg-background border border-stroke shadow-sm flex items-center justify-center">
        <img
          src="/assets/prime-badge.svg"
          alt=""
          className="size-[1.6rem] shrink-0"
        />
      </div>
    );
  }

  return (
    <div className="rounded-[1.6rem] bg-background border border-stroke shadow-sm p-[1.2rem] flex flex-col gap-[1.2rem]">
      <div className="flex flex-col gap-[0.2rem] pl-[0.4rem]">
        <span className="medium5 text-primary">
          {t('personalAccount.sidebarNavigation.prime.title')}
        </span>
        <span className="p6 text-secondary">
          {t('personalAccount.sidebarNavigation.prime.lessFees')}
        </span>
        <span className="p6 text-secondary">
          {t('personalAccount.sidebarNavigation.prime.moreOptions')}
        </span>
      </div>
      <Button
        size="small"
        variant="secondary"
        disabled
        className="w-full h-[3.2rem] rounded-[1rem] py-[0.6rem] pl-[1.2rem] pr-[1.8rem] gap-[0.8rem] headline6">
        <img
          src="/assets/prime-badge.svg"
          alt=""
          className="size-[1.6rem] shrink-0"
        />
        {t('personalAccount.sidebarNavigation.prime.upgrade')}
      </Button>
    </div>
  );
};

export { SidebarPrimeBlock };
